export default {
      id: "icon-pansements-usage",
      viewBox: "0 0 107 107",
      url: __webpack_public_path__ + "icons.svg#icon-pansements",
      toString: function () {
        return this.url;
      }
    }